import { useState } from 'react';
import { Card, Row, Col, Spin, Button } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { DescriptionList } from '../../../../../components';
import { commentInfo } from '../listContent/commentInfo';
import { CardTitle } from '../../../../../components/CardTitle/CardTitle';
import { CommentModal } from '../modals/CommentModal';

export const CommentCard = ({
  comment,
  isLoading,
  supervisionId,
  refreshData,
  setRefreshData
}) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <Spin spinning={isLoading}>
      <Card
        title={
          <CardTitle icon="message">{t('supervisions.show.comment')}</CardTitle>
        }
        extra={
          <Button type="link" onClick={() => setIsModalOpen(true)}>
            <EditOutlined />
          </Button>
        }
      >
        <Row>
          <Col span={30}>
            <DescriptionList data={commentInfo(comment, t)} translate />
          </Col>
        </Row>
      </Card>
      <CommentModal
        supervisionId={supervisionId}
        comment={comment}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        refreshData={refreshData}
        setRefreshData={setRefreshData}
      />
    </Spin>
  );
};

CommentCard.propTypes = {
  comment: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  supervisionId: PropTypes.string,
  refreshData: PropTypes.bool.isRequired,
  setRefreshData: PropTypes.func.isRequired
};

CommentCard.defaultProps = {
  comment: '',
  supervisionId: ''
};
